export default "__VITE_ASSET__MB$_Fpgh__"